<template>
  <div>
    <section class="container">
      <div class="fixed header">
        <i class="material-icons smallSize" @click="index = 0">refresh</i>
        <router-link :to="{ name: 'unitCleaner', params: { unitId } }"
          ><i class="material-icons smallSize">close</i>
        </router-link>
        <span>{{ $t('inventoryCheck') }}</span>
      </div>
      <div
        v-if="current"
        class="fixed fixed--center"
        style="z-index: 3"
        :class="{ transition: isVisible }"
      >
        <Vue2InteractDraggable
          v-if="isVisible"
          :interact-event-bus-events="interactEventBus"
          :interact-out-of-sight-x-coordinate="500"
          :interact-max-rotation="15"
          :interact-x-threshold="200"
          :interact-y-threshold="200"
          @draggedRight="emitAndNext('match')"
          @draggedLeft="rejectDragged"
          class="rounded-borders card card--one"
        >
          <div class="flex flex--center" style="height: 100%">
            <img :src="`${current.img_path}`" class="rounded-borders" />
            <div class="text">
              <h1>{{ current.stock_curr }}</h1>
            </div>
            <div class="comments">
              <h3>{{ current.product_name }}</h3>
              <p>{{ current.comments }}</p>
            </div>
          </div>
        </Vue2InteractDraggable>
      </div>
      <div
        v-if="next"
        class="rounded-borders card card--two fixed fixed--center"
        style="z-index: 2"
      >
        <div class="flex flex--center" style="height: 100%">
          <img :src="`${next.img_path}`" class="rounded-borders" />
          <div class="text">
            <h1>{{ next.stock_curr }} / {{ next.stock_max }}</h1>
          </div>
          <div class="comments">
            <h3>{{ next.product_name }}</h3>
            <p>{{ next.comments }}</p>
          </div>
        </div>
      </div>
      <div
        v-if="index + 2 < cards.length"
        class="rounded-borders card card--three fixed fixed--center"
        style="z-index: 1"
      >
        <div class="flex flex--center" style="height: 100%">
          <h1>test</h1>
        </div>
      </div>
      <div v-if="current" class="footer fixed">
        <div class="btn btn--decline" @click="reject">
          <i class="material-icons redColor">close</i>
        </div>
        <div class="btn btn--accept" @click="match">
          <i class="material-icons greenColor">done</i>
        </div>
      </div>
    </section>
    <b-modal id="stock-update-modal" hide-footer @close="handleCancel">
      <template v-slot:modal-title>
        {{ $t('actualStock') }}
      </template>
      <div class="stockInput">
        <!-- <label>{{ $t('actualStock') }}</label> -->
        <input
          v-model="stock_curr"
          class="fieldPrice inp"
          :class="{ errorBg: $v.stock_curr.$error }"
          type="number"
          name="stock_curr"
          @blur="$v.stock_curr.$touch()"
          placeholder="50"
        />
        <span>{{ $t('pcs') }}</span>
        <template v-if="$v.stock_curr.$error">
          <p v-if="!$v.stock_curr.required" class="errorMessage">
            {{ $t('currentStockReq') }}
          </p>
        </template>
        <p>
          <button
            class="login-btn"
            sytle="text-transform: uppercase;"
            @click="updateStock()"
          >
            {{ $t('sendNotification') }}
          </button>
        </p>
      </div>
    </b-modal>
    <b-modal
      id="success-modal-inventory"
      title=""
      hide-footer
      @close="inventoryCheckSucceed"
    >
      <div>
        <h2>{{ $t('restockSuccess') }}</h2>
        <br />
        <h3>{{ $t('restockSuccess2') }}</h3>
        <br />
        <figure class="about-img2">
          <img src="../../assets/static/images/illustrations/cleaner.svg" />
        </figure>
        <br />
        <SuccessTickIconAnim
          @perform-tick-click-action="inventoryCheckSucceed"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Vue2InteractDraggable, InteractEventBus } from 'vue2-interact'
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import SuccessTickIconAnim from '@/components/common/SuccessTickIconAnim.vue'

const EVENTS = {
  MATCH: 'match',
  REJECT: 'reject'
}
export default {
  name: 'SwipeableCards',
  components: {
    Vue2InteractDraggable,
    SuccessTickIconAnim
  },
  validations: {
    stock_curr: { required }
  },
  data() {
    return {
      unitId: this.$route.params.unitId,
      baseUrl: process.env.VUE_APP_API_URL,
      isVisible: true,
      index: 0,
      interactEventBus: {
        draggedRight: EVENTS.MATCH,
        draggedLeft: EVENTS.REJECT
      },
      cards: [
        {
          src: 'jabkaMicak.jpg',
          currentStock: 8,
          maxStock: 8,
          productName: 'Jabka sok 1l',
          comments:
            'Bottles are placed on the shelf. In storage you can find new bottles for restocking'
        },
        {
          src: 'grad.jpg',
          currentStock: 2,
          maxStock: 2,
          productName: 'Rebula Svetlik 0,7l',
          comments:
            'Bottles are placed in the bathroom. In storage you can find new bottles for restocking'
        },
        {
          src: 'hero.jpg',
          currentStock: 10,
          maxStock: 10,
          productName: 'Sivka mazilo',
          comments:
            'Bottles are placed in the bathroom. In storage you can find new bottles for restocking'
        }
      ],
      stock_curr: 0,
      isOpenedThroughClicked: false,
      restockProducts: []
    }
  },
  async created() {
    this.cards = await this.$store.dispatch(
      'unitProduct/fetchUnitProducts',
      this.$route.params.unitId
    )
  },
  computed: {
    ...mapState(['unitProduct']),
    current() {
      if (this.cards.length > 0) return this.cards[this.index]
      return false
    },
    next() {
      if (this.cards.length > 1) return this.cards[this.index + 1]
      return false
    }
  },
  methods: {
    handleCancel() {
      if (this.isOpenedThroughClicked) {
        this.isOpenedThroughClicked = false
      } else {
        setTimeout(() => (this.isVisible = false), 200)
        setTimeout(() => {
          this.isVisible = true
        }, 200)
      }
    },
    match() {
      this.isOpenedThroughClicked = true
      InteractEventBus.$emit(EVENTS.MATCH)
      // this.$emit(EVENTS.MATCH, this.cards[this.index])
    },
    reject() {
      this.isOpenedThroughClicked = true
      this.stock_curr = this.cards[this.index].stock_curr
      this.$bvModal.show('stock-update-modal')
    },
    rejectDragged() {
      if (this.isOpenedThroughClicked === true) {
        this.isOpenedThroughClicked = false
      } else {
        this.stock_curr = this.cards[this.index].stock_curr
        this.$bvModal.show('stock-update-modal')
      }
    },
    async emitAndNext(event) {
      this.$emit(event, this.cards[this.index])
      setTimeout(() => (this.isVisible = false), 200)
      setTimeout(() => {
        this.index++
        this.isVisible = true
      }, 200)
      if (this.cards.length === this.index + 1) {
        this.markInventoryActivity()
        this.restockProducts = await this.$store.dispatch(
          'unitProduct/fetchUnitProductsToRestock',
          this.$route.params.unitId
        )
        if (this.restockProducts.length !== 0) {
          this.disableRestock = false
          this.$router.push({
            name: 'restockCards',
            params: {
              unitId: this.$route.params.unitId
            }
          })
        } else {
          this.$bvModal.show('success-modal-inventory')
        }
      }
    },
    async markInventoryActivity() {
      const user = JSON.parse(localStorage.getItem('user'))
      this.$store.dispatch(
        'unit/markInventoryActivity',
        {
          unit_id: this.$route.params.unitId,
          cleaner_id: user.id
        }
      )
    },
    async updateStock() {
      try {
        await this.$store.dispatch('unitProduct/editUnitProductStock', {
          unit_id: this.$route.params.unitId,
          product_id: this.cards[this.index].product_id,
          stock_curr: this.stock_curr
        })
        this.$bvModal.hide('stock-update-modal')
        setTimeout(() => (this.isVisible = false), 200)
        setTimeout(() => {
          this.index++
          this.isVisible = true
        }, 200)
        if (this.cards.length === this.index + 1)
          this.$router.push({
            path: '/cleaner-panel/units/' + this.$i18n.locale
          })
        if (this.isOpenedThroughClicked === true)
          InteractEventBus.$emit(EVENTS.REJECT)
        else this.isOpenedThroughClicked = false
      } catch (error) {
        alert(error)
      }
    },
    inventoryCheckSucceed() {
      this.$router.push({
        name: 'unit-list-cleaner',
        params: { lang: this.$i18n.locale }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-btn {
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}

.stockInput span {
  font-weight: 600;
  font-size: 1em;
  margin-left: 5px;
  color: var(--bg);
}

.fieldPrice {
  width: 30%;
}

.inp {
  border: none;
  border-bottom: 0.2px solid var(--bg);
  padding: 5px 10px;
  outline: none;
  margin-bottom: 1.2em;
  background-color: var(--grey-superlight);
}
.inp:hover {
  border-color: var(--primary);
}

[placeholder]:focus::-webkit-input-placeholder {
  transition: text-indent 0.4s 0.4s ease;
  text-indent: -100%;
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.sm {
  font-size: 0.85em;
}

.xs {
  font-size: 0.75em;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

.container {
  background: #eceff1;
  width: 100%;
  height: 100vh;
}

.header {
  width: 100%;
  height: 60vh;
  z-index: 0;
  top: 0;
  left: 0;
  color: white;
  text-align: center;
  background: var(--bg);
  background: -webkit-linear-gradient(
    16deg,
    rgba(76, 158, 134, 1) 0%,
    rgba(61, 113, 109, 1) 8%,
    rgba(47, 71, 85, 1) 38%,
    rgba(44, 62, 80, 1) 47%,
    rgba(44, 62, 80, 1) 50%,
    rgba(44, 62, 80, 1) 80%
  );
  background: linear-gradient(
    16deg,
    rgba(76, 158, 134, 1) 0%,
    rgba(61, 113, 109, 1) 8%,
    rgba(47, 71, 85, 1) 38%,
    rgba(44, 62, 80, 1) 47%,
    rgba(44, 62, 80, 1) 50%,
    rgba(44, 62, 80, 1) 80%
  );
  clip-path: polygon(0 1%, 100% 0%, 100% 76%, 0 89%);
  display: flex;
  span {
    display: block;
    font-size: 2rem;
    padding-top: 4rem;
    text-shadow: 1px 1px 1px black;
    margin-left: 40%;
  }
  @media (max-width: 768px) {
    span {
      margin-left: 10%;
    }
  }
  i {
    padding-top: 24px;
    padding-left: 10px;
  }
}

.text {
  position: absolute;
  h1 {
    font-size: 4.5rem;
    font-weight: 600;
  }
}

.comments {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
  background: rgba(0, 0, 0, 0.5);
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  p {
    font-size: 1rem;
    color: white;
    text-align: justify;
    padding: 15px;
  }
  h3 {
    margin: 0;
    padding-top: 1em;
  }
}

.footer {
  width: 77vw;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  padding-bottom: 30px;
  justify-content: space-around;
  align-items: center;
}

.material-icons {
  font-size: 60px;
  font-weight: 900;
}
.smallSize {
  font-size: 35px !important;
}

.flex {
  display: flex;
  &--center {
    align-items: center;
    justify-items: center;
    justify-content: center;
  }
}

.fixed {
  position: fixed;
  &--center {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.rounded-borders {
  border-radius: 12px;
}
.card {
  width: 80vw;
  height: 60vh;
  color: white;
  img {
    object-fit: cover;
    display: block;
    width: 100%;
    height: 100%;
  }
  &--one {
    background-color: gray;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14),
      0 2px 1px -1px rgba(0, 0, 0, 0.12);
  }
  &--two {
    background-color: gray;
    transform: translate(-48%, -48%);
    box-shadow: 0 6px 6px -3px rgba(0, 0, 0, 0.2),
      0 10px 14px 1px rgba(0, 0, 0, 0.14), 0 4px 18px 3px rgba(0, 0, 0, 0.12);
  }
  &--three {
    background: rgba(black, 0.8);
    transform: translate(-46%, -46%);
    box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2),
      0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12);
  }
}

.btn {
  position: relative;
  width: 70px;
  height: 70px;
  padding: 0.2rem;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 6px 6px -3px rgba(0, 0, 0, 0.02),
    0 10px 14px 1px rgba(0, 0, 0, 0.02), 0 4px 18px 3px rgba(0, 0, 0, 0.02);
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  &:active {
    transform: translateY(4px);
  }
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &::before {
      content: '';
    }
  }
  &--accept {
    background-color: none;
    padding: 0.5rem;
    color: green;
    box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2),
      0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12);
  }
  &--decline {
    color: red;
  }
}

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 200px;
  text-align: center;
  vertical-align: top;
}

.transition {
  animation: appear 200ms ease-in;
}
@keyframes appear {
  from {
    transform: translate(-48%, -48%);
  }
  to {
    transform: translate(-50%, -50%);
  }
}
</style>
